/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-06-07 17:35:39
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-04 11:04:11
 */

import { RecipeCategory } from '../models/recipe'
import { API_PREFIX } from './constant'
import { ContentType, MultiPartFormData, Request } from './request'

export interface versionManagementParams {
  current: number
  tenantId?: any
  size: number
  name?: string
}

export function versionManagementLit(params: versionManagementParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/version/page`,
    method: 'GET',
    params,
  }
}

export function versionDetailAsync(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-administer/version/detailWithProperties`,
    method: 'GET',
    params: { id },
  }
}

export function versionListAsync(): Request {
  return {
    url: `${API_PREFIX}/blade-administer/versionproperties/getAttributes`,
    method: 'GET',
  }
}

export function jurisdictionAsync(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-administer/version/grantPermissions`,
    method: 'GET',
    params: { id },
  }
}

export interface AddVersiobSubmitParams {
  version: {
    id: any
    name?: any
    labels: any
    versionEdition?: any
  }
  versionPropertiesList?: []
}

export function addVersiobSubmitAsync(body: AddVersiobSubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/version/submit`,
    method: 'POST',
    body,
  }
}

export interface versionCheckNameParams {
  versionId: any
  name?: string
}

export function addVersiobCheckNameAsync(
  params: versionCheckNameParams
): Request {
  return {
    url: `${API_PREFIX}/blade-administer/version/checkName`,
    method: 'GET',
    params,
  }
}

export interface allSelectMenusSubmitParams {
  versionId: any
  menuList?: any
}

export function allSelectMenusSubmit(body: allSelectMenusSubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/version/saveMenuPermissions`,
    method: 'POST',
    body,
  }
}

export interface allMenuListParams {
  edition: any
  versionId?: any
}
export function allMenuListAsync(params: allMenuListParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/version/selectMenuTree`,
    method: 'GET',
    params
  }
}

export function menuListAsync(edition: any): Request {
  return {
    url: `${API_PREFIX}/blade-administer/menu/SysMenuList`,
    method: 'GET',
    params: { edition },
  }
}


export function threeMenuListAsync(edition: any): Request {
  return {
    url: `${API_PREFIX}/blade-administer/menu/sysMenuListThird`,
    method: 'GET',
    params: { edition },
  }
}

export function selectMenus(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-administer/version/detail`,
    method: 'GET',
    params: { id },
  }
}

export function selectMenusDetail(id: any): Request {
  return {
    url: `${API_PREFIX}/blade-administer/version/selectTreeVersionNavigationDetail`,
    method: 'GET',
    params: { id },
  }
}

export interface selectMenusSubmitParams {
  id: any
  sysMenuIds?: any
  sysMenuThirdIds?: any
}

export function selectMenusSubmit(body: selectMenusSubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/version/changePermissions`,
    method: 'POST',
    body,
  }
}

//版本列表

export function versionPageAsync(): Request {
  return {
    url: `${API_PREFIX}/blade-administer/version/VersionListSimple`,
    method: 'GET',
  }
}


export interface versionChangeModalSubmitParams {
  id: any
  tenantIdList: any
}
export function versionChangeModal(params: versionChangeModalSubmitParams): Request {
  return {
    url: `${API_PREFIX}/blade-administer/version/grantPermissionBatch`,
    method: 'GET',
    params,
  }
}
